"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoutingCard = RoutingCard;
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardActionArea2 = _interopRequireDefault(require("@mui/material/CardActionArea"));
var _CardActions2 = _interopRequireDefault(require("@mui/material/CardActions"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../hooks");
var _elevationsChartCard = require("./elevations-chart-card");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Stats({
  route
}) {
  const {
    toTime,
    toDistance
  } = (0, _hooks.useUnits)();
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, route ? toTime(route.duration || 0) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 50
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, "\xB7"), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, route ? toDistance(route.distances.total || 0) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 50
  })));
}
function ComputedRouteCardContent({
  route,
  hasNoTitle,
  title,
  enableElevationsChart,
  actions
}) {
  const {
    toDistance
  } = (0, _hooks.useUnits)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      padding: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
  }, !hasNoTitle && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    fontSize: "1.1rem",
    fontWeight: 600
  }, route ? title || /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: `commons.routing.titles.${route.labelKey}`
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  })), /*#__PURE__*/_react.default.createElement(Stats, {
    route: route
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "primary",
    variant: "body2"
  }, route ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.routing.distances.cycling_roads",
    values: {
      value: route.recommendedRoadsPercentage
    }
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), route ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    height: 8,
    position: "relative",
    width: 200
  }, route.recommendedRoadsPercentage > 0 && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "bottom",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.routing.distances.recommended",
      values: {
        distance: toDistance(route.distances.recommendedRoads)
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    borderRadius: 1,
    height: 8,
    left: 0,
    position: "absolute",
    sx: {
      backgroundColor: _hooks.facilityDistributionColors.recommended
    },
    top: 0,
    width: `${route.recommendedRoadsPercentage}%`,
    zIndex: 3
  })), route.normalRoadsPercentage > 0 && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "bottom",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.routing.distances.normal",
      values: {
        distance: toDistance(route.distances.normalRoads)
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    borderRadius: 1,
    height: 8,
    left: 0,
    position: "absolute",
    sx: {
      backgroundColor: _hooks.facilityDistributionColors.normal
    },
    top: 0,
    width: `${route.recommendedRoadsPercentage + route.normalRoadsPercentage}%`,
    zIndex: 2
  })), route.discouragedRoadsRoadsPercentage > 0 && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "bottom",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.routing.distances.discouraged",
      values: {
        distance: toDistance(route.distances.discouragedRoads)
      }
    })
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    borderRadius: 1,
    height: 8,
    left: 0,
    position: "absolute",
    sx: {
      backgroundColor: _hooks.facilityDistributionColors.discouraged
    },
    top: 0,
    width: "100%",
    zIndex: 1
  }))) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 8,
    sx: {
      borderRadius: 1
    },
    variant: "rectangular",
    width: 200
  })), enableElevationsChart && /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_Divider2.default, null), /*#__PURE__*/_react.default.createElement(_elevationsChartCard.ElevationsChartCard, {
    disableElevation: true,
    route: route
  })))), actions && /*#__PURE__*/_react.default.createElement(_CardActions2.default, {
    sx: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, actions));
}
function RoutingCard({
  variant,
  route,
  hasNoTitle,
  title,
  enableElevationsChart,
  linkProps,
  actions,
  onClick,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_Card2.default, _extends({
    sx: {
      borderRadius: 2
    },
    variant: variant
  }, props), onClick || linkProps ? /*#__PURE__*/_react.default.createElement(_CardActionArea2.default, _extends({}, linkProps, {
    onClick: onClick
  }), /*#__PURE__*/_react.default.createElement(ComputedRouteCardContent, {
    actions: actions,
    enableElevationsChart: enableElevationsChart,
    hasNoTitle: hasNoTitle,
    route: route,
    title: title
  })) : /*#__PURE__*/_react.default.createElement(ComputedRouteCardContent, {
    actions: actions,
    enableElevationsChart: enableElevationsChart,
    hasNoTitle: hasNoTitle,
    route: route,
    title: title
  }));
}